import {
  aDeleteCustomEntityType,
  mockDeleteCustomEntityTypeMutation,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockDeleteCustomEntityTypeMutation(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Mutation',
          deleteCustomEntityType: aDeleteCustomEntityType(),
        },
      });
    }
  ),
];
